import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { logout } from 'redux/modules/auth';

class Header extends Component {
  static propTypes = {
    history: PropTypes.objectOf(PropTypes.any),
    location: PropTypes.objectOf(PropTypes.any),
    user: PropTypes.shape({
      email: PropTypes.string
    }),
    logout: PropTypes.func
  };
  render() {
    const styles = require('./Header.less');
    const logo = require('../../../static/images/logo/logo.svg');
    return (
      <header className={ styles.header }>
        <div className={ styles.inner }>
          <div className={ styles.wrap }>
            <Link to="/">
              <img src={ logo } width="160" height="38" alt="mvoter" />
            </Link>
            { this.props.user === null ?
              <ul>
                <li><Link to="/login">Войти</Link></li>
                <li><Link to="/login?subId=register" className={ styles.button }>Регистрация</Link></li>
              </ul>
              : 
              <ul>
                <li><Link to="/cabinet">Личный кабинет</Link></li>
                <li><a onClick={ () => this.props.logout() }>Выйти</a></li>
              </ul>
            }
          </div>
        </div>
      </header>
    )
  }
}

export default connect(
  state => ({
    user: state.auth.user
  }),
  { logout }
)(Header);
